import { api } from './client';
import type { Page } from './catalogs';
import type { CancellableState } from './cancellation';

export interface AdditionalExpenseItem {
  id?: string;
  line_number: number;
  goods_receipt_item_id: string;
  distribution_base: string;
  allocated_amount?: string;
  /** 0410: override Дт рядка (авто: рахунок рядка надходження / 281). */
  account_code?: string | null;
  receipt_account_code?: string | null;
  project_id?: string | null;
  /** Збагачення з backend (GET single): дані рядка/документа прихода. */
  nomenclature_id?: string | null;
  receipt_quantity?: string | null;
  receipt_amount?: string | null;
  receipt_id?: string | null;
  receipt_document_number?: string | null;
  /** 2026-08-09: постачальник надходження (колонка ТЧ). */
  receipt_contractor_name?: string | null;

}

export interface AdditionalExpenseListItem {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  contractor_id: string;
  expense_type: string;
  amount_without_vat: string;
  vat_amount: string;
  total_amount: string;
  posted: boolean;
  deletion_mark: boolean;
  project_id?: string | null;
  external_source?: string | null;
  // Block 5.3c:
  state?: CancellableState;
}

export interface AdditionalExpense extends AdditionalExpenseListItem {
  contract_id: string;
  distribute_by: string;
  supplier_doc_number: string | null;
  supplier_doc_date: string | null;
  vat_rate_id: string | null;
  posted_at: string | null;
  comment: string | null;
  items: AdditionalExpenseItem[];
  // Block 5.3c:
  cancelled_at?: string | null;
  cancellation_reason?: string | null;
}

export interface AdditionalExpenseCreate {
  organization_id: string;
  document_number: string;
  document_date: string;
  contractor_id: string;
  contract_id: string;
  expense_type?: string;
  distribute_by?: string;
  supplier_doc_number?: string | null;
  supplier_doc_date?: string | null;
  amount_without_vat: string;
  vat_rate_id?: string | null;
  vat_amount?: string;
  comment?: string | null;
  /** 0410: override Кт (авто: правила контрагента / 631). */
  settlement_account_code?: string | null;
  items: AdditionalExpenseItem[];
  project_id?: string | null;
}

export type AdditionalExpenseUpdate = Partial<AdditionalExpenseCreate>;

export const additionalExpenses = {
  list: (params?: {
    organization_id?: string; contractor_id?: string;
    expense_type?: string; posted?: boolean; limit?: number; offset?: number; sort_by?: string; sort_dir?: 'asc' | 'desc';
    date_from?: string; date_to?: string;
  }) =>
    api.get<Page<AdditionalExpenseListItem>>('/additional-expenses', { params }).then((r) => r.data),
  get: (id: string) =>
    api.get<AdditionalExpense>(`/additional-expenses/${id}`).then((r) => r.data),
  create: (payload: AdditionalExpenseCreate) =>
    api.post<AdditionalExpense>('/additional-expenses', payload).then((r) => r.data),
  update: (id: string, payload: AdditionalExpenseUpdate) =>
    api.patch<AdditionalExpense>(`/additional-expenses/${id}`, payload).then((r) => r.data),
  remove: (id: string) =>
    api.delete(`/additional-expenses/${id}`).then(() => undefined),
  post: (id: string) =>
    api.post<AdditionalExpense>(`/additional-expenses/${id}/post`).then((r) => r.data),
  unpost: (id: string) =>
    api.post<AdditionalExpense>(`/additional-expenses/${id}/unpost`).then((r) => r.data),
  cancel: (id: string, reason: string) =>
    api.post(`/additional-expenses/${id}/cancel`, { cancellation_reason: reason }).then((r) => r.data),
};
